import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { color } from '@core-ds/primitives';
var Label = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   background: ", ";\n   color: ", ";\n   border-radius: 4px;\n   font-size: 14px;\n   font-weight: bold;\n   padding: 3px 4px;\n   z-index: 1;\n"])), color.gray[50], color.gray[600]);
export default Label;